<template>
    <div class="footer">
        <div class="item">
            <div class="title">FUTURE VIEW LENDING SERVICE CORPORATION</div>
            <div class="text">
                Future View Lending Service Corporation is a leading provider of quality lending solutions, dedicated to
                empowering individuals and businesses to achieve their financial goals with transparency and
                reliability.
            </div>
        </div>
        <div class="item">
            <div class="title">PAGES</div>
            <div class="text">
                Home
            </div>
            <div class="text">
                CONTACT US
            </div>
        </div>
        <div class="item">
            <div class="title">CONTACT US</div>
            <div class="text color">
                Unit 25D, 2/F Zeta II Building, 191 Salcedo St., Legazpi Village, San Lorenz
            </div>
            <div class="text color">
                Tel:+63 921 538 1930
            </div>
            <!-- <div class="text color">
                Mail:service@futureviewlendingservice.com
            </div> -->
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    padding: 39px 194px 55px;
    box-sizing: border-box;
    background: #00291D;
    display: flex;
    justify-content: space-between;

    .item {
        max-width: 378px;

        .title {
            font-weight: bold;
            font-size: 15px;
            color: #FFFFFF;
            line-height: 23px;
            margin-bottom: 11px;
        }

        .text {
            font-weight: bold;
            font-size: 15px;
            color: #B9B9B9;
            line-height: 23px;
            margin-bottom: 11px;
        }

        .color {
            color: #FFFFFF;
        }
    }
}
</style>